import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AbstractPeopleService, IPerson } from "../interfaces";
import { WebServiceResponse } from "../interfaces/helpTarget";
import { LogClass, Logger } from "../logger";

@LogClass()
@Injectable({
  providedIn: "root"
})
export class SpPeopleService implements AbstractPeopleService {
  private logger: Logger;

  constructor(private http: HttpClient) {
    this.logger.debug("ctor");
  }

  public GetPerson(login: string): Observable<IPerson> {
    return this.GetPersons([login]).pipe(map((p) => p[0]));
  }

  public GetPersons(logins: string[]): Observable<IPerson[]> {
    const params = (logins || [])
      .map((x) => "login=" + encodeURIComponent(x))
      .join("&");
    const url = "/api/People?" + params;
    return this.http
      .get<WebServiceResponse<IPerson[]>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("GetPersons"),
        map((res) => res.data)
      );
  }

  public SearchPeople(query: string): Observable<IPerson[]> {
    const url = "/api/People/Query?query=" + encodeURIComponent(query);
    return this.http
      .get<WebServiceResponse<IPerson[]>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("SearchPeople"),
        map((res) => res.data)
      );
  }
}
